/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { getHygraphCosmosPageData, ContentTypeNames } from "@cosmos/hygraph-data";
import { CosmosEntityFragment, EntityTypeName, EntityWhereInput, Locale } from "@cosmos/hygraph-schema";

import { HeroQuery, HeroTypeNames } from "./page.types";

export const getHeroContentType = (typenameStr: string): ContentTypeNames => {
	let contentType: ContentTypeNames = "CosmosPageHeroAlpha";
	switch (typenameStr) {
		case "CosmosHeroAlpha":
			contentType = "CosmosPageHeroAlpha";
			break;
		case "CosmosHeroGlow":
			contentType = "CosmosPageHeroGlow";
			break;
		case "CosmosHeroArticleImage":
			contentType = "CosmosPageHeroArticleImage";
			break;
		case "CosmosHeroBravo":
			contentType = "CosmosPageHeroBravo";
			break;
	}

	return contentType;
};

export const getHeroEntityQuery = async (
	heroEntity: EntityWhereInput | null | undefined,
	typenameStr: string,
	locale: string,
	preview?: string,
	endpoint?: string,
): Promise<HeroQuery | null> => {
	if (heroEntity) {
		const promise = getHygraphCosmosPageData(
			getHeroContentType(typenameStr),
			{
				entities: [heroEntity],
				locale: [locale, Locale.En] as Locale[],
			},
			preview,
			endpoint,
		).catch(() => console.error("Hero load error", { heroEntity })) as Promise<HeroQuery>;
		return promise;
	}

	return null;
};

/**
 * Fetch the entity for the hero
 */
export const getHeroDetails = async (
	hero: CosmosEntityFragment | undefined | null,
	locale: string,
	preview?: string,
	endpoint?: string,
): Promise<HeroQuery | null> => {
	if (hero) {
		const typenameStr = hero?.__typename as HeroTypeNames;
		const heroEntity: EntityWhereInput | null | undefined = {
			id: hero.id,
			stage: hero.stage,
			typename: EntityTypeName[typenameStr],
		};
		return getHeroEntityQuery(heroEntity, typenameStr, locale, preview, endpoint);
	}
	return null;
};
